/**
 * @desc 新建年计划基础信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanYearInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/web/plan/year/addPlanInfo',
    data,
  });
}

export function mock(
  data: defs.PlanYearInfoAddRequest,
): Promise<defs.StandardReturn<number>> {
  return defHttp.post({
    url: '/mock/web/plan/year/addPlanInfo',
    data,
  });
}
